<div class="fi-selection-container">
  @if (unhealthyFI) {
  <pbb-notice-banner
    [noticeVariant]="'info'"
     [dismissable]="true"
    [noticeTitle]="'COMMON.LANDING_FI_DISABLED_NOTICE_TITLE' | translate"
    [noticeMessage]="'COMMON.LANDING_FI_DISABLED_NOTICE_MESSAGE' | translate"
    [closeButtonAriaLabel]="'ARIA_LABEL.CLOSE' | translate"
  >
  </pbb-notice-banner>
  }
  <mat-nav-list class="fi-selection-list" id="fi-selection-list" role="navigation">
    @for (institution of financialInstitutions.data; track $index) { @if (institution.priority) {
    <a
      mat-list-item
      [attr.id]="'fi-selection-list-item-' + institution.display_name"
      (click)="institution.health_status && !isLinked(institution) && fiSelected.next(institution)"
      (keydown.enter)="institution.health_status && !isLinked(institution) && fiSelected.next(institution)"
      [attr.aria-label]="institution.display_name"
      [attr.tabindex]="institution.health_status && !isLinked(institution) ? '0' : '-1'"
      [attr.aria-disabled]="!institution.health_status || isLinked(institution)"
      [disabled]="!institution.health_status || isLinked(institution)"
    >
      <img pbbImgError="assets/images/bank.png" alt="{{ institution.display_name }}" [src]="institution.logo" />
      <div class="fi-selection-item-label">
        <span>{{ institution.display_name || '' }}</span>
        @if (!institution.health_status) {
        <span>{{ 'COMMON.LABEL_UNAVAILABLE' | translate }}</span>
        } @if (isLinked(institution)) {
        <span>{{ 'COMMON.ALREADY_LINKED' | translate }}</span>
        }
      </div>
    </a>
    } }
  </mat-nav-list>
</div>
@if (financialInstitutions.isLoading) {
<ngx-skeleton-loader count="5" appearance="line"></ngx-skeleton-loader>
} @if (financialInstitutions.error) {
<div>
  {{ 'COMMON.ERROR.TRY_AGAIN' | translate }}
</div>
}
